"use client";

import { MarketplaceListingCard } from "./Card";
import { MarketplaceListingListCard } from "./ListCard";
import type { MarketplaceListingItem } from "@/types/api/marketplace";
import { cn } from "@/lib/utils";

interface ListingGridProps {
  items: MarketplaceListingItem[];
  className?: string;
}

export function ListingGrid({
  items,
  className,
}: ListingGridProps) {
  if (items.length === 0) return null;

  return (
    <>
      <div
        className={cn(
          "border-gray-200 -mx-4 flex w-[calc(100%+2rem)] flex-col rounded-none border-x-0 border-t-0 bg-white sm:-mx-6 sm:w-[calc(100%+3rem)] md:hidden",
          className
        )}>
        {items.map((item) => (
          <MarketplaceListingListCard
            key={item.id}
            {...item}
            isGrouped
          />
        ))}
      </div>

      <div
        className={cn(
          "hidden gap-4 md:grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4",
          className
        )}>
        {items.map((item) => (
          <MarketplaceListingCard key={item.id} {...item} />
        ))}
      </div>
    </>
  );
}
